import { createI18n } from "vue-i18n";
import es from "@/locales/es.json";
import en from "@/locales/en.json";
import it from "@/locales/it.json";
import el from "@/locales/el.json";
import drawerEn from "@/locales/drawer.en.json";
import drawerIt from "@/locales/drawer.it.json";
import drawerEl from "@/locales/drawer.el.json";
export const SUPPORTED_LOCALES = [
    "es",
    "en",
    "it",
    "el",
];
const LOCALE_STORAGE_KEY = "micentrum_locale";
const INTL_LOCALE_TAGS = {
    es: "es-CL",
    en: "en-US",
    it: "it-IT",
    el: "el-GR",
};
const DRAWER_LABELS = {
    en: drawerEn,
    it: drawerIt,
    el: drawerEl,
};
const isSupportedLocale = (value) => value === "es" || value === "en" || value === "it" || value === "el";
const getInitialLocale = () => {
    const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (isSupportedLocale(savedLocale)) {
        return savedLocale;
    }
    const browser = navigator.language.toLowerCase();
    if (browser.startsWith("en"))
        return "en";
    if (browser.startsWith("it"))
        return "it";
    if (browser.startsWith("el"))
        return "el";
    return "es";
};
const initialLocale = getInitialLocale();
const messages = {
    es,
    en,
    it,
    el,
};
export const i18n = createI18n({
    legacy: false,
    locale: initialLocale,
    fallbackLocale: "es",
    messages,
});
/** Etiqueta BCP 47 para Intl según el idioma activo. */
export const intlLocaleTag = (locale = String(i18n.global.locale.value)) => {
    if (isSupportedLocale(locale)) {
        return INTL_LOCALE_TAGS[locale];
    }
    return INTL_LOCALE_TAGS.es;
};
export const localeDisplayKey = (locale) => {
    if (locale === "en")
        return "language.english";
    if (locale === "it")
        return "language.italian";
    if (locale === "el")
        return "language.greek";
    return "language.spanish";
};
export const setAppLocale = (locale) => {
    i18n.global.locale.value = locale;
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    document.documentElement.lang = locale;
};
export const getDrawerLabel = (label, locale) => {
    if (locale === "es")
        return label;
    return DRAWER_LABELS[locale][label] || label;
};
setAppLocale(initialLocale);
